import { environment as defaultEnvironment } from './environment';

export const environmentLoader = new Promise<any>((resolve, reject) => {
    const assets_url = './assets';
    const xmlhttp = new XMLHttpRequest(),
        method = 'GET',
        url = assets_url + '/environments/environment.json';
    xmlhttp.open(method, url, true);
    xmlhttp.onload = function () {
        if (xmlhttp.status === 200 && !xmlhttp.responseText.includes('Loading')) {
            resolve(JSON.parse(xmlhttp.responseText));
        } else {
            resolve(defaultEnvironment);
        }
    };
    xmlhttp.send();
});
